import {useMutation, useQuery, useQueryClient} from '@tanstack/react-query'
import {api} from '@/lib/api'
import type {components} from '@/lib/api-schema'

export type FilaPropuesta = components['schemas']['FilaPropuestaRead']
export type Propuesta = components['schemas']['PropuestaRead']
export type FilaConfirmar = components['schemas']['FilaConfirmar']
export type PropuestaConfirmarResult = components['schemas']['PropuestaConfirmarResult']

/** Se recalcula en cada lectura y nunca se guarda; antes de la Fase 2 el endpoint contesta 409. */
export function usePlanPropuesta(businessId: string | undefined) {
  return useQuery({
    queryKey: ['plan-propuesta', businessId],
    queryFn: async () => (await api.get<Propuesta>(`/businesses/${businessId}/sgsst/plan/propuesta`)).data,
    enabled: !!businessId,
  })
}

export function useConfirmarPropuesta(businessId: string) {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (filas: FilaConfirmar[]) =>
      (await api.post<PropuestaConfirmarResult>(`/businesses/${businessId}/sgsst/plan/propuesta/confirmar`, {filas}))
        .data,
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: ['plan-propuesta', businessId]})
      queryClient.invalidateQueries({queryKey: ['actions', businessId]})
      queryClient.invalidateQueries({queryKey: ['sgsst', businessId]})
    },
  })
}
